import { render, staticRenderFns } from "./QuizBufferingView.vue?vue&type=template&id=19c374b6"
import script from "./QuizBufferingView.vue?vue&type=script&lang=js"
export * from "./QuizBufferingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports